import { render, staticRenderFns } from "./UrunVariantlar.vue?vue&type=template&id=633b5e30&scoped=true"
import script from "./UrunVariantlar.vue?vue&type=script&lang=js"
export * from "./UrunVariantlar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b5e30",
  null
  
)

export default component.exports